// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Article40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Article40: FC<Article40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M11.583 28.361h11.528v-2.778H11.583v2.778Zm0-6.972h16.834V18.61H11.583v2.778Zm0-6.972h16.834v-2.778H11.583v2.778ZM7.778 35c-.75 0-1.4-.275-1.952-.826-.55-.551-.826-1.202-.826-1.952V7.778c0-.75.275-1.4.826-1.952C6.377 5.276 7.028 5 7.778 5h24.444c.75 0 1.4.275 1.952.826.55.551.826 1.202.826 1.952v24.444c0 .75-.275 1.4-.826 1.952-.551.55-1.202.826-1.952.826H7.778Zm0-2.778h24.444V7.778H7.778v24.444Z" />
        </svg>
    );
};

export default Article40;
